//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Groups */
export const Group = {
    /** RSR - Rock Administration */
    GroupAdministrators: "628C51A8-4613-43ED-A18D-4A6FB999273E",
    /** RSR - Benevolence Group Guid */
    GroupBenevolence: "02FA0881-3552-42B8-A519-D021139B800F",
    /** The Calendar Administrators Group guid */
    GroupCalendarAdministrators: "FDA9D63F-B0B1-43E8-8B82-0255E5D99F26",
    /** The Communication Administrators Group guid */
    GroupCommunicationAdministrators: "B1906B7D-1A1E-41B9-BBA4-F4482CECAF7B",
    /** The group of communication approvers */
    GroupCommunicationApprovers: "74B1B26E-1955-49A7-4C59-ABCD7543FF71",
    /** The Connection Administrators Group guid */
    GroupConnectionAdministrators: "060971D2-EAF9-4C0D-B6F6-F01725CAA5AC",
    /** Group of people who are responsible for the integrity of the data. */
    GroupDataIntegrityWorker: "40517E10-0F2D-4C61-AA8D-BDE36D58C63A",
    /** RSR - Event Registration Administration Guid */
    GroupEventRegistrationAdministrators: "2A92086B-DFF0-4B9C-46CB-4DAD805615AF",
    /** The Finance Administrators Group guid */
    GroupFinanceAdministrators: "6246A7EF-B7A3-4C8C-B1E4-3FF114B84559",
    /** The Finance Users Group guid */
    GroupFinanceUsers: "2539CF5D-E2CE-4706-8BBF-4A9DF8E763E9",
    /** The security group used by mobile app */
    GroupMobileApp: "EDD336D5-1429-41D9-8D41-2581A05F0E16",
    /** RSR - Mobile Application Users */
    GroupMobileApplicationUsers: "42175217-1BA4-401B-AA4E-21EC4F1F0AB4",
    /** Get the photo request application group */
    GroupPhotoRequest: "2108EF9C-10DC-4466-973D-D25AAB7818BE",
    /** RSR - Prayer Access */
    GroupRsrPrayerAccess: "9E17621E-F559-44E9-8C40-E8CF44CF8FCF",
    /** Group of people who are responsible for the safety and security of staff and members */
    GroupSafetySecurity: "32E80B6C-A1EB-40FD-BEC3-E11DE8FF75AB",
    /** A parent Group for all Sign-up Groups */
    GroupSignupGroups: "D649638A-EF91-42D8-9B38-32172D614A5F",
    /** Gets the staff-like member group guid (Staff Users) */
    GroupStaffLikeMembers: "300BA2C8-49A3-44BA-A82A-82E3FD8C3745",
    /** Gets the staff member group guid (Staff Users) */
    GroupStaffMembers: "2C112948-FF4C-46E7-981A-0257681EADF4",
    /** WEB - Admistration */
    GroupWebAdministrators: "1918E74F-C00D-4DDD-94C4-2E7209CE12C3",
};
